module.exports = __webpack_public_path__ + "img/Like-Normal-State.090a80d4.svg";